<template>
    <div class="min-h-screen flex flex-column" v-if="!innerUsage">
       <TopNavBar :role="''" />

        <div class="flex-1">
            <slot />
        </div>
    </div>
    <div class="flex-1" v-else>
        <slot />
    </div>
    <!-- Footer Section -->
    <FooterPage v-if="!role" />
</template>

<script setup>
import {  defineProps } from "vue";
import FooterPage from "@/layout/FooterPage.vue";
import TopNavBar from '@/layout/TopNavBar.vue';
defineProps({
    role: {
        type: String,
        default: '',
    },
    innerUsage: {
        type: Boolean,
        default: false
    }
});

</script>

<style scoped>
.nav-bar {
    min-height: 60px;
}

.active-btn {
    border-bottom-color: var(--teal-500) !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

.topnavbar {
    height: auto;
    max-width: 160px;
    cursor: pointer;
}

.btn-topbar {
    font-size: 14px;
    font-weight: 500;
    color: var(--gray-600) !important;
}

.btn-topbar:hover {
    background-color: transparent !important;
    transform: scale(1.05);
}

/* Default outline button */
.btn-default-outline {
    border-color: var(--teal-700) !important;
    color: black !important;
}

.btn-default-outline:hover {
    background-color: var(--teal-500) !important;
    color: #fff !important;
}

.btn-student-outline {
    border-color: var(--orange-500) !important;
    color: var(--orange-500) !important;
}

.btn-student-outline:hover {
    background-color: var(--orange-500) !important;
    color: #fff !important;
}

.btn-tutor-outline {
    border-color: var(--teal-500) !important;
    color: var(--teal-500) !important;
}

.btn-tutor-outline:hover {
    background-color: var(--teal-500) !important;
    color: #fff !important;
}

.btn-institution-outline {
    border-color: var(--yellow-500) !important;
    color: var(--yellow-700) !important;
}

.btn-institution-outline:hover {
    background-color: var(--yellow-500) !important;
    color: #fff !important;
}




.bg-orange-300 {
    background-color: var(--orange-700) !important;
}

.bg-teal-100 {
    background-color: var(--teal-100) !important;
}

.bg-yellow-500 {
    background-color: var(--yellow-100) !important;
}

.bg-teal-1300 {
    background-color: var(--teal-1300) !important;
}


/* Mobile Styles */
@media (max-width: 767px) {
    .nav-bar {
        padding: 0.5rem 1rem;
    }

    .topnavbar {
        max-width: 120px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .nav-bar {
        padding: 0.75rem 2rem;
    }
}

@media (min-width: 1024px) {
    .nav-bar {
        padding: 0.75rem 3rem;
    }
}
</style>